export var CATEGORIES;
(function (CATEGORIES) {
    CATEGORIES["BRANDS"] = "fab";
    CATEGORIES["DUOTONE"] = "fad";
    CATEGORIES["LIGHT"] = "fal";
    CATEGORIES["REGULAR"] = "far";
    CATEGORIES["SOLID"] = "fas";
})(CATEGORIES || (CATEGORIES = {}));
export const DEFAULT_BG_COLOR = 'rgba(0, 0, 0, 0.1)';
export const DEFAULT_HEIGHT = '30px';
export const ICON_SIZE_TO_BG_SIZE_RATIO = 1.8;
//# sourceMappingURL=constants.js.map